var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row no-gutters"},_vm._l((_vm.$store.state.products),function(product){return _c('ProductCard',{key:product.id,attrs:{"product":product}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }